var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboardingMenu4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#FFE291"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.753 14C28.9113 14 29.8652 14.8752 29.9894 16.0004L31.2571 16C32.1753 16 32.9283 16.7071 33.0013 17.6065L33.0071 17.75V20.75C33.0071 22.483 31.6506 23.8992 29.9415 23.9949L29.7312 24.0007C29.0634 26.0909 27.2328 27.6615 25.0002 27.9517L24.9995 29.5H26.753C28.4861 29.5 29.9023 30.8565 29.9979 32.5656L30.003 32.75V33.25C30.003 33.6297 29.7209 33.9435 29.3548 33.9932L29.253 34H19.25C18.8703 34 18.5565 33.7178 18.5069 33.3518L18.5 33.25V32.75C18.5 31.017 19.8565 29.6008 21.5656 29.5051L21.75 29.5H23.4995L23.4999 27.9513C21.2686 27.6601 19.4393 26.09 18.7718 24.0007L18.7455 24C16.9506 24 15.4955 22.5449 15.4955 20.75V17.75C15.4955 16.7835 16.279 16 17.2455 16L18.5137 16.0004C18.6379 14.8752 19.5917 14 20.75 14H27.753ZM31.2571 17.5H30.003V22.4829C30.8031 22.3703 31.4295 21.7168 31.5004 20.9041L31.5071 20.75V17.75C31.5071 17.6317 31.4249 17.5325 31.3144 17.5066L31.2571 17.5ZM18.5 17.5H17.2455C17.1075 17.5 16.9955 17.6119 16.9955 17.75V20.75C16.9955 21.6332 17.6498 22.3635 18.5 22.4829V17.5Z",
    fill: "#F6AB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingMenu4);
export default __webpack_public_path__ + "static/media/onboarding-menu-4.fda56a6810e72a5d4125fc08116def43.svg";
export { ForwardRef as ReactComponent };